import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    letters: []
  },
  mutations: {
    createLetter(state, letter){
      state.letters.push(letter);
    }
  },
  actions: {
  },
  modules: {
  }
})
